<template>
  <div>
    <div>
      <a-card class="dashboard-card">
        <div class="d-flex align-items-center timestamp-dashboard mb-4">
          <span>Terakhir Diperbarui: </span>
          <div class="timestamp-values">
            <span class="ml-2 custom-icon-gray"><CalendarOutlined /> {{ formatDate.date }}</span>
            <span class="ml-2 custom-icon-gray"><ClockCircleOutlined /> {{ formatDate.time }}</span>
          </div>
        </div>

        <div class="ringkasan-wrapper">
          <RingkasanCard
            title="Total Pendaftaran"
            layout="single"
            :left-value="membershipSummary.totalMembership.total || 0"
            :clickable="true"
            to="/mobile-cms/member-application"
          >
            <template #subtext>
              <svg
                v-if="isPositiveDiff(membershipSummary.totalMembership)"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M4.75 2.875L1.0625 6.5625L0 5.5L5.5 0L11 5.5L9.9375 6.5625L6.25 2.875V9H4.75V2.875ZM4.75 13V10.5H6.25V13H4.75ZM4.75 16V14.5H6.25V16H4.75Z"
                  fill="#28A745"
                />
              </svg>
              <svg
                v-else-if="membershipSummary.totalMembership.difference < 0"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M6.25 13.125L9.9375 9.4375L11 10.5L5.5 16L0 10.5L1.0625 9.4375L4.75 13.125V7H6.25V13.125ZM6.25 3V5.5H4.75V3H6.25ZM6.25 0V1.5H4.75V0H6.25Z"
                  fill="#DC3545"
                />
              </svg>
              {{ formatDiffMetric(membershipSummary.totalMembership, false) }}
            </template>
          </RingkasanCard>

          <RingkasanCard
            title="Verifikasi Admin"
            layout="single"
            :left-value="membershipSummary.pending.total || 0"
            :clickable="true"
            to="/mobile-cms/member-application"
            :query="{ status: ['pending'] }"
          >
            <template #subtext>
              <svg
                v-if="isPositiveDiff(membershipSummary.pending)"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M4.75 2.875L1.0625 6.5625L0 5.5L5.5 0L11 5.5L9.9375 6.5625L6.25 2.875V9H4.75V2.875ZM4.75 13V10.5H6.25V13H4.75ZM4.75 16V14.5H6.25V16H4.75Z"
                  fill="#28A745"
                />
              </svg>
              <svg
                v-else-if="membershipSummary.pending.difference < 0"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M6.25 13.125L9.9375 9.4375L11 10.5L5.5 16L0 10.5L1.0625 9.4375L4.75 13.125V7H6.25V13.125ZM6.25 3V5.5H4.75V3H6.25ZM6.25 0V1.5H4.75V0H6.25Z"
                  fill="#DC3545"
                />
              </svg>
              {{ formatDiffMetric(membershipSummary.pending, false) }}
            </template>
          </RingkasanCard>

          <RingkasanCard
            title="Menunggu Revisi"
            layout="single"
            :left-value="membershipSummary.revision.total || 0"
            :clickable="true"
            to="/mobile-cms/member-application"
            :query="{ status: ['revision'] }"
          >
            <template #subtext>
              <svg
                v-if="isPositiveDiff(membershipSummary.revision)"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M4.75 2.875L1.0625 6.5625L0 5.5L5.5 0L11 5.5L9.9375 6.5625L6.25 2.875V9H4.75V2.875ZM4.75 13V10.5H6.25V13H4.75ZM4.75 16V14.5H6.25V16H4.75Z"
                  fill="#28A745"
                />
              </svg>
              <svg
                v-else-if="membershipSummary.revision.difference < 0"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M6.25 13.125L9.9375 9.4375L11 10.5L5.5 16L0 10.5L1.0625 9.4375L4.75 13.125V7H6.25V13.125ZM6.25 3V5.5H4.75V3H6.25ZM6.25 0V1.5H4.75V0H6.25Z"
                  fill="#DC3545"
                />
              </svg>
              {{ formatDiffMetric(membershipSummary.revision, false) }}
            </template>
          </RingkasanCard>
        </div>

        <div class="ringkasan-wrapper mt-4">
          <RingkasanCard
            title="Rata-Rata Waktu Proses"
            layout="single"
            :left-value="
              membershipSummary.averageProcessTime.total == 0 &&
              membershipSummary.averageProcessTime.hasData
                ? '1'
                : membershipSummary.averageProcessTime.total
            "
            :left-label="'Hari'"
            :right-label="
              membershipSummary.averageProcessTime.total == 0 &&
              membershipSummary.averageProcessTime.hasData
                ? '<'
                : ''
            "
          >
            <template #subtext>
              <svg
                v-if="(membershipSummary.averageProcessTime.difference || 0) > 0"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M4.75 2.875L1.0625 6.5625L0 5.5L5.5 0L11 5.5L9.9375 6.5625L6.25 2.875V9H4.75V2.875ZM4.75 13V10.5H6.25V13H4.75ZM4.75 16V14.5H6.25V16H4.75Z"
                  fill="#28A745"
                />
              </svg>
              <svg
                v-else-if="(membershipSummary.averageProcessTime.difference || 0) < 0"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M6.25 13.125L9.9375 9.4375L11 10.5L5.5 16L0 10.5L1.0625 9.4375L4.75 13.125V7H6.25V13.125ZM6.25 3V5.5H4.75V3H6.25ZM6.25 0V1.5H4.75V0H6.25Z"
                  fill="#DC3545"
                />
              </svg>
              {{ formatDiffMetric(membershipSummary.averageProcessTime, true) }}
            </template>
          </RingkasanCard>

          <RingkasanCard
            title="Rekap Pendaftaran Selesai"
            layout="dual"
            left-label="Disetujui"
            :left-value="membershipSummary.finishedApplicationRecap.totalApproved || 0"
            right-label="Ditolak"
            :right-value="membershipSummary.finishedApplicationRecap.totalRejected || 0"
            :clickable="true"
            to="/mobile-cms/member-application"
            :query="{ status: ['approved', 'rejected'] }"
          >
            <template #subtext>
              <svg
                v-if="(membershipSummary.finishedApplicationRecap.difference || 0) > 0"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M4.75 2.875L1.0625 6.5625L0 5.5L5.5 0L11 5.5L9.9375 6.5625L6.25 2.875V9H4.75V2.875ZM4.75 13V10.5H6.25V13H4.75ZM4.75 16V14.5H6.25V16H4.75Z"
                  fill="#28A745"
                />
              </svg>
              <svg
                v-else-if="(membershipSummary.finishedApplicationRecap.difference || 0) < 0"
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M6.25 13.125L9.9375 9.4375L11 10.5L5.5 16L0 10.5L1.0625 9.4375L4.75 13.125V7H6.25V13.125ZM6.25 3V5.5H4.75V3H6.25ZM6.25 0V1.5H4.75V0H6.25Z"
                  fill="#DC3545"
                />
              </svg>
              <span>
                {{
                  formatDiffMetric(
                    {
                      total:
                        (membershipSummary.finishedApplicationRecap.totalApproved || 0) +
                        (membershipSummary.finishedApplicationRecap.totalRejected || 0),
                      yesterday: membershipSummary.finishedApplicationRecap.yesterday || 0,
                      difference: membershipSummary.finishedApplicationRecap.difference || 0,
                    },
                    true,
                  )
                }}
              </span>
            </template>
          </RingkasanCard>

          <RingkasanCard
            title="Pendaftaran Masih Dalam Proses"
            layout="single"
            :left-value="membershipSummary.pending.total + membershipSummary.revision.total || 0"
            :clickable="true"
            to="/mobile-cms/member-application"
            :query="{ status: ['pending', 'revision'] }"
          >
            <template #subtext>
              <svg
                v-if="
                  membershipSummary.pending.difference + membershipSummary.revision.difference > 0
                "
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M4.75 2.875L1.0625 6.5625L0 5.5L5.5 0L11 5.5L9.9375 6.5625L6.25 2.875V9H4.75V2.875ZM4.75 13V10.5H6.25V13H4.75ZM4.75 16V14.5H6.25V16H4.75Z"
                  fill="#28A745"
                />
              </svg>
              <svg
                v-else-if="
                  membershipSummary.pending.difference + membershipSummary.revision.difference < 0
                "
                width="11"
                height="16"
                viewBox="0 0 11 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1"
              >
                <path
                  d="M6.25 13.125L9.9375 9.4375L11 10.5L5.5 16L0 10.5L1.0625 9.4375L4.75 13.125V7H6.25V13.125ZM6.25 3V5.5H4.75V3H6.25ZM6.25 0V1.5H4.75V0H6.25Z"
                  fill="#DC3545"
                />
              </svg>
              {{
                formatDiffMetric(
                  {
                    total:
                      (membershipSummary.pending.total || 0) +
                      (membershipSummary.revision.total || 0),
                    yesterday:
                      (membershipSummary.pending.yesterday || 0) +
                      (membershipSummary.revision.yesterday || 0),
                    difference:
                      (membershipSummary.pending.difference || 0) +
                      (membershipSummary.revision.difference || 0),
                  },
                  false,
                )
              }}
            </template>
          </RingkasanCard>
        </div>

        <div class="summary-wrapper-second mt-4">
          <div class="summary-card-second">
            <proporsi-status-pendaftaran
              :data="useDummyData ? dummyStatusDistribution : proporsiStatusFromSummary"
            />
          </div>

          <div class="summary-card-second">
            <tren-pendaftaran-member :data="useDummyData ? dummyTrendData : null" />
          </div>
        </div>

        <div class="summary-wrapper-second mt-4">
          <div class="summary-card-second">
            <jumlah-member
              :title="'Jumlah Member Per Cabang'"
              :data="useDummyData ? dummyCabangList : cabangDistributionList"
              :is-full="true"
            />
          </div>

          <div class="summary-card-second">
            <jumlah-member
              :title="'Jumlah Member Per Subspesialisasi'"
              :data="useDummyData ? dummySubspesialisasiList : subspesialisasiDistributionList"
              :is-full="true"
            />
          </div>
          <!-- Jumlah Member Per Kelompok Kerja -->
          <!-- <div class="kerja-subspesialisasi-card">
            <div class="summary-card-second">
              <jumlah-member
                :title="'Jumlah Member Per Kelompok Kerja'"
                :dummy-data="dummyKelompokKerjaList"
              />
            </div>
          </div> -->
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons-vue'
import moment from 'moment'
import { computed, ref, onMounted } from 'vue'
import { mobileCmsMemberApplicationAPI } from '@/services/axios/perki/mobileCms'
import RingkasanCard from '../dashboard/components/RingkasanCard.vue'

// Import all dashboard components
import ProporsiStatusPendaftaran from '../dashboard/components/proporsi-status-pendaftaran.vue'
import TrenPendaftaranMember from '../dashboard/components/tren-pendaftaran-member.vue'
import JumlahMember from '../dashboard/components/jumlah-member.vue'

export default {
  name: 'Dashboard',
  components: {
    CalendarOutlined,
    ClockCircleOutlined,
    RingkasanCard,
    ProporsiStatusPendaftaran,
    TrenPendaftaranMember,
    JumlahMember,
  },
  setup() {
    const useDummyData = false
    const currentDate = ref(moment())
    const formatDate = computed(() => {
      return {
        date: currentDate.value.format('DD/MM/YYYY'),
        time: currentDate.value.format('HH:mm:ss'),
      }
    })

    // Daftar Tugas - fetch from API
    const dataDaftarTugas = ref([])
    const loadingTugas = ref(false)

    const initialSummary = {
      totalMembership: { total: 0, yesterday: 0, difference: 0 },
      pending: { total: 0, yesterday: 0, difference: 0 },
      approved: { total: 0, yesterday: 0, difference: 0 },
      rejected: { total: 0, yesterday: 0, difference: 0 },
      revision: { total: 0, yesterday: 0, difference: 0 },
      averageProcessTime: { total: 0, yesterday: 0, difference: 0, hasData: false },
      finishedApplicationRecap: { total: 0, yesterday: 0, difference: 0 },
      inProgressApplication: { total: 0, yesterday: 0, difference: 0 },
      lastUpdated: null,
    }

    const dummySummary = {
      totalMembership: { total: 128, yesterday: 118, difference: 10 },
      pending: { total: 34, yesterday: 31, difference: 3 },
      approved: { total: 72, yesterday: 65, difference: 7 },
      rejected: { total: 14, yesterday: 16, difference: -2 },
      revision: { total: 8, yesterday: 7, difference: 1 },
      lastUpdated: moment().toISOString(),
    }

    const dummyStatusDistribution = {
      statusPendaftaran: [
        { status: 'Verifikasi Admin', count: 34, percentage: 26.6 },
        { status: 'Menunggu Revisi', count: 72, percentage: 56.3 },
        { status: 'Disetujui', count: 14, percentage: 10.9 },
        { status: 'Ditolak', count: 8, percentage: 6.2 },
      ],
    }

    const dummyTrendData = {
      data: [12, 15, 18, 21, 19, 23],
      categories: ['Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr'],
    }

    const dummyCabangList = [
      { name: 'DKI Jakarta', role: 'Cabang', npa: 'NPA PERKI : 120', count: 120 },
      { name: 'Jawa Barat', role: 'Cabang', npa: 'NPA PERKI : 98', count: 98 },
      { name: 'Jawa Timur', role: 'Cabang', npa: 'NPA PERKI : 86', count: 86 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
      { name: 'Sumatera Utara', role: 'Cabang', npa: 'NPA PERKI : 54', count: 54 },
    ]

    const dummyKelompokKerjaList = [
      { name: 'Aritmia', role: 'Kelompok Kerja', npa: 'NPA PERKI : 35', count: 35 },
      { name: 'Intervensi', role: 'Kelompok Kerja', npa: 'NPA PERKI : 29', count: 29 },
      { name: 'Heart Failure', role: 'Kelompok Kerja', npa: 'NPA PERKI : 22', count: 22 },
      { name: 'Preventif', role: 'Kelompok Kerja', npa: 'NPA PERKI : 17', count: 17 },
      { name: 'Preventif', role: 'Kelompok Kerja', npa: 'NPA PERKI : 17', count: 17 },
      { name: 'Preventif', role: 'Kelompok Kerja', npa: 'NPA PERKI : 17', count: 17 },
      { name: 'Preventif', role: 'Kelompok Kerja', npa: 'NPA PERKI : 17', count: 17 },
      { name: 'Preventif', role: 'Kelompok Kerja', npa: 'NPA PERKI : 17', count: 17 },
    ]

    const dummySubspesialisasiList = [
      {
        name: 'Interventional Cardiology',
        role: 'Subspesialisasi',
        npa: 'NPA PERKI : 40',
        count: 40,
      },
      { name: 'Electrophysiology', role: 'Subspesialisasi', npa: 'NPA PERKI : 27', count: 27 },
      { name: 'Cardiac Imaging', role: 'Subspesialisasi', npa: 'NPA PERKI : 24', count: 24 },
      { name: 'Heart Failure', role: 'Subspesialisasi', npa: 'NPA PERKI : 21', count: 21 },
    ]

    const membershipSummary = ref(initialSummary)
    const loadingSummary = ref(false)
    const cabangDistributionList = ref([])
    const subspesialisasiDistributionList = ref([])

    const proporsiStatusFromSummary = computed(() => {
      const pending = membershipSummary.value?.pending?.total || 0
      const revision = membershipSummary.value?.revision?.total || 0
      const approved = membershipSummary.value?.approved?.total || 0
      const rejected = membershipSummary.value?.rejected?.total || 0
      const total = pending + revision + approved + rejected

      const percentage = value => {
        if (total <= 0) return 0
        return Number(((value / total) * 100).toFixed(1))
      }

      return {
        statusPendaftaran: [
          {
            status: 'Verifikasi Admin',
            count: pending,
            percentage: percentage(pending),
          },
          {
            status: 'Menunggu Revisi',
            count: revision,
            percentage: percentage(revision),
          },
          {
            status: 'Disetujui',
            count: approved,
            percentage: percentage(approved),
          },
          {
            status: 'Ditolak',
            count: rejected,
            percentage: percentage(rejected),
          },
        ],
      }
    })

    // Get user role from localStorage
    const userRole = ref('')
    const storedUserData = localStorage.getItem('mobile_cms_user')
    if (storedUserData) {
      const userData = JSON.parse(storedUserData)
      userRole.value = userData.role || ''
    }

    const fetchSummaryCards = async () => {
      if (useDummyData) {
        membershipSummary.value = dummySummary
        currentDate.value = moment()
        return
      }

      loadingSummary.value = true
      try {
        const { data } = await mobileCmsMemberApplicationAPI.getStatusSummary()
        membershipSummary.value = data?.result || initialSummary

        // Update timestamp after successful fetch
        currentDate.value = moment()
      } catch (error) {
        console.error('Error fetching summary cards:', error)
        membershipSummary.value = initialSummary
      } finally {
        loadingSummary.value = false
      }
    }

    const mapDistributionItems = items => {
      if (!Array.isArray(items)) return []

      return items.map(item => ({
        name: item?.name || '-',
        count: item?.count || 0,
      }))
    }

    const fetchMemberDistribution = async () => {
      if (useDummyData) {
        cabangDistributionList.value = mapDistributionItems(dummyCabangList)
        subspesialisasiDistributionList.value = mapDistributionItems(dummySubspesialisasiList)
        return
      }

      try {
        const { data } = await mobileCmsMemberApplicationAPI.getMemberDistribution()
        cabangDistributionList.value = mapDistributionItems(data?.result?.perkiCabang)
        subspesialisasiDistributionList.value = mapDistributionItems(data?.result?.subspesialisasi)
      } catch (error) {
        console.error('Error fetching member distribution:', error)
        cabangDistributionList.value = []
        subspesialisasiDistributionList.value = []
      }
    }

    const checkDiff = (total, yesterday, isMonthly) => {
      const diff = total - yesterday
      if (diff > 0) {
        if (!isMonthly) return `+${diff} (dari 1 hari lalu)`
        return `+${diff} (dari bulan lalu)`
      } else if (diff < 0) {
        if (!isMonthly) return `-${diff} (dari 1 hari lalu)`
        return `-${diff} (dari bulan lalu)`
      }
      return 'Tidak ada perubahan'
    }

    const formatDiffMetric = (metric, isMonthly) => {
      if (!metric) return '-'
      return checkDiff(metric.total || 0, metric.yesterday || 0, isMonthly)
    }

    const isPositiveDiff = metric => (metric?.difference || 0) > 0

    const checkDiffColor = (total, yesterday) => {
      const diff = total - yesterday
      if (diff > 0) return '#28A745'
      if (diff < 0) return '#DC3545'
      return '#666'
    }

    onMounted(() => {
      // Fetch summary cards on mount
      fetchSummaryCards()
      fetchMemberDistribution()
    })

    return {
      useDummyData,
      currentDate,
      formatDate,
      dataDaftarTugas,
      loadingTugas,
      membershipSummary,
      loadingSummary,
      proporsiStatusFromSummary,
      cabangDistributionList,
      subspesialisasiDistributionList,
      dummyStatusDistribution,
      dummyTrendData,
      dummyCabangList,
      dummyKelompokKerjaList,
      dummySubspesialisasiList,
      userRole,
      checkDiff,
      formatDiffMetric,
      isPositiveDiff,
      checkDiffColor,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../mixins.scss';

.dashboard-card {
  border: none;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
}

.timestamp-dashboard {
  font-size: 16px;
  color: #444444;
  background-color: #ededed;
  width: fit-content;
  padding: 4px 16px;
  border-radius: 24px;

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}

.timestamp-values {
  display: flex;
  @media (max-width: 480px) {
    gap: 8px;
  }
}

.custom-icon-gray {
  display: flex;
  align-items: center;
  gap: 4px;
}

.custom-header-tugas {
  font-size: 16px;
  font-weight: 700;
  color: $primary;
}

.custom-card-outside-tugas {
  max-height: 500px;
  overflow-y: auto;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 10px;

    &:hover {
      background: #ccc;
    }
  }
}

.summary-wrapper {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;

  &-second {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    margin: 0;
  }

  &-full {
    display: flex;
    width: 100%;
  }
}

.summary-card {
  flex: 1 1 calc(33.333% - 24px);
  min-width: 260px;
  padding: 24px;
  border-radius: 24px;
  background: white;
  border: 1px solid #e4e9f0;
  box-shadow: 0px 15px 15px -5px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin-left: 10px;
  margin-right: 10px;
  &-second {
    flex: 1 1 calc(50% - 24px);
    min-width: 260px;
    padding: 24px;
    border-radius: 24px;
    background: white;
    border: 1px solid #e4e9f0;
    box-shadow: 0px 15px 15px -5px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  &-full {
    width: 100%;
    padding: 24px;
    border-radius: 24px;
    background: white;
    border: 1px solid #e4e9f0;
    box-shadow: 0px 15px 15px -5px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }
}

.kerja-subspesialisasi-card {
  flex: 1 1 calc(50% - 24px);
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.custom-title-card-summary {
  font-size: 18px;
  font-weight: 700;
  color: $primary;
  text-align: center;
}

.custom-title-card-summary-center {
  font-size: 14px;
}

.custom-count-surat-one {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
}

.custom-diff-surat-one {
  font-size: 12px;
  color: #282828;
  text-align: center;
}

.custom-count-surat-two {
  font-size: 30px;
  font-weight: 700;
}

.rotate-180 {
  transform: rotate(180deg);
  transform-origin: center;
  transition: transform 0.2s ease;
}

.empty-tugas {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  color: #999;
  font-size: 14px;
}

.empty-state-summary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  color: #999;
  font-size: 14px;
  width: 100%;
}

.ringkasan-wrapper {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
}

.ringkasan-card {
  flex: 1 1 calc(33.333% - 24px);
  min-width: 260px;
  border-radius: 24px;
  background: white;
  border: 1px solid #e4e9f0;
  box-shadow: 0px 15px 15px -5px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

:deep(.ant-card-body) {
  padding: 0px !important;
}

@media (max-width: 1024px) {
  .summary-card {
    flex: 1 1 calc(50% - 24px);

    &-second {
      flex: 1 1 100%;
    }
  }
}

@media (max-width: 600px) {
  .summary-card {
    flex: 1 1 100%;
  }
}

.skeleton-loading {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.skeleton-item {
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 8px;
  animation: skeleton-loading 1.5s infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
